// 阻止浏览器默认的 hash 跳转行为（当 hash 指向 mt-product-detail 时）
// 必须在页面加载早期执行，在 DOM 加载之前
(function preventHashScroll() {
  // 检查 URL 中是否有指向 mt-product-detail 的 hash
  const hash = window.location.hash;
  if (hash && hash.startsWith('#mt-product-detail-')) {
    // 阻止默认滚动行为
    if (document.documentElement) {
      document.documentElement.style.scrollBehavior = 'auto';
    }
    if (document.body) {
      document.body.style.scrollBehavior = 'auto';
    }
    
    // 立即滚动到顶部
    window.scrollTo(0, 0);
    
    // 恢复滚动行为
    setTimeout(() => {
      if (document.documentElement) {
        document.documentElement.style.scrollBehavior = '';
      }
      if (document.body) {
        document.body.style.scrollBehavior = '';
      }
    }, 100);
  }
})();

function mtFindVariantFromOptions(section, productData) {
  if (!productData || !productData.variants) return null;

    const selectedOptions = [];
  const variantGroups = Array.from(
    section.querySelectorAll('.mt-product-detail__variant-options')
  ).sort((a, b) => {
    const posA = parseInt(a.dataset.optionPosition, 10) || 0;
    const posB = parseInt(b.dataset.optionPosition, 10) || 0;
        return posA - posB;
      });

  variantGroups.forEach((group) => {
      const selectedOption = group.querySelector('.is-selected');
      if (selectedOption) {
        selectedOptions.push(selectedOption.dataset.optionValue);
      } else {
        selectedOptions.push(null);
      }
    });

  return (
    productData.variants.find((variant) => {
      if (!variant.title || variant.title === 'Default Title') {
        return selectedOptions.every((opt) => !opt);
      }

      const variantOptions = variant.title.split(' / ').map((v) => v.trim());

      return selectedOptions.every((selected, index) => {
        if (!selected) return true;
        return variantOptions[index] === selected;
      });
    }) || productData.variants[0]
  );
  }

function mtUpdatePriceForVariant(priceElement, variant) {
    if (!variant || !priceElement) return;
    
    const price = (variant.price / 100).toFixed(2);
  const comparePrice = variant.compare_at_price
    ? (variant.compare_at_price / 100).toFixed(2)
    : null;
  const currency = window.Shopify?.currency?.active || '$';

  let html = '<span class="price">';
    if (comparePrice && parseFloat(comparePrice) > parseFloat(price)) {
    html += `
        <span class="price__compare">${currency}${comparePrice}</span>
        <span class="price__regular">${currency}${price}</span>
      `;
    } else {
    html += `<span class="price__regular">${currency}${price}</span>`;
    }
  html += '</span>';
    
  priceElement.innerHTML = html;
  }

function mtUpdateSubtotal(section) {
  const subtotalEl = section.querySelector('[data-subtotal-price]');
  if (!subtotalEl) return;

  const bssPriceEl =
    document.querySelector('.bss-po-product-price') ||
    section.querySelector('.bss-po-product-price');
  if (bssPriceEl && bssPriceEl.textContent.trim()) {
    console.debug('[mt-product-detail] subtotal from BSS price:', bssPriceEl.textContent.trim());
    subtotalEl.textContent = bssPriceEl.textContent.trim();
    return;
  }

  const priceRoot = section.querySelector('[data-product-price]');
  if (!priceRoot) return;

  const text = priceRoot.textContent.replace(',', '') || '';
  const match = text.match(/([\d.]+)/);
  let baseCents = 0;
  if (match && match[1]) {
    const num = parseFloat(match[1]);
    if (!Number.isNaN(num)) baseCents = Math.round(num * 100);
  }

  let extraCents = 0;
  if (window.BSS_PO && typeof window.BSS_PO.totalCartExtraPrice === 'number') {
    extraCents = Math.round(window.BSS_PO.totalCartExtraPrice * 100);
  }

  const totalCents = baseCents + extraCents;

  console.debug('[mt-product-detail] subtotal calc', {
    baseCents,
    extraCents,
    totalCents,
    priceText: text.trim(),
    bssExtra: window.BSS_PO?.totalCartExtraPrice,
  });

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    subtotalEl.textContent = window.Shopify.formatMoney(totalCents);
    } else {
    const currency = window.Shopify?.currency?.active || '$';
    const price = (totalCents / 100).toFixed(2);
    subtotalEl.textContent = `${currency}${price}`;
  }
}

function mtUpdateFeaturedMediaForVariant(section, variant) {
    if (!variant.featured_media) return;

  const mediaItems = section.querySelectorAll('.mt-product-detail__media-item');
  const thumbnails = section.querySelectorAll('.mt-product-detail__thumbnail');

  mediaItems.forEach((item) => {
      if (item.dataset.mediaId == variant.featured_media) {
      mediaItems.forEach((mi) => mi.classList.remove('is-active'));
        item.classList.add('is-active');
        
      const matchingThumb = Array.from(thumbnails).find(
        (thumb) => thumb.dataset.mediaId == variant.featured_media
      );
      if (matchingThumb) {
        thumbnails.forEach((thumb) => thumb.classList.remove('is-active'));
        matchingThumb.classList.add('is-active');
      }
    }
  });
}

function initMtProductDetailVariants(section) {
  const productData = window.__MT_PRODUCT__ || null;
  const variantOptions = section.querySelectorAll(
    '.mt-product-detail__variant-option'
  );
  if (!variantOptions.length) return;

  const variantTitle = section.querySelector('[data-variant-title]');
  const variantIdInput = section.querySelector('[data-variant-id]');
  const priceElement = section.querySelector('[data-product-price]');

  mtUpdateSubtotal(section);

  variantOptions.forEach((option) => {
    option.addEventListener('click', () => {
      if (option.disabled) return;

      const group = option.closest('.mt-product-detail__variant-options');
      group
        .querySelectorAll('.mt-product-detail__variant-option')
        .forEach((opt) => opt.classList.remove('is-selected'));
      option.classList.add('is-selected');

      if (productData && productData.variants && variantIdInput) {
        const selectedVariant = mtFindVariantFromOptions(section, productData);
        if (selectedVariant) {
          variantIdInput.value = selectedVariant.id;

          if (variantTitle) {
            variantTitle.textContent =
              selectedVariant.title && selectedVariant.title !== 'Default Title'
                ? ` - ${selectedVariant.title}`
                : '';
          }

          if (priceElement) {
            mtUpdatePriceForVariant(priceElement, selectedVariant);
          }

          mtUpdateFeaturedMediaForVariant(section, selectedVariant);
        }
      }

      mtUpdateSubtotal(section);
    });
  });
}

/* ------------------------- Discount code copy helper ------------------------ */

function initDiscountCodeForSection(section) {
  const copyButtons = section.querySelectorAll('[data-copy-discount-code]');
  if (copyButtons.length) {
    copyButtons.forEach((button) => {
      button.addEventListener('click', async () => {
        const discountItem = button.closest(
          '.mt-product-detail__discount-item'
        );
        if (!discountItem) return;

        const codeEl =
          discountItem.querySelector('[data-discount-code-value]');
        if (!codeEl) return;

        let code = codeEl.getAttribute('data-discount-code-value');
        if (!code) code = codeEl.textContent.trim();
      if (!code) return;

        const discountBlock = button.closest(
          '.mt-product-detail__discount'
        );
        const messageEl =
          discountBlock?.querySelector('[data-discount-message]');

        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(code);
          } else {
            const ta = document.createElement('textarea');
            ta.value = code;
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            ta.style.left = '-9999px';
            document.body.appendChild(ta);
            ta.focus();
            ta.select();
              document.execCommand('copy');
            document.body.removeChild(ta);
          }

          button.classList.add('copied');
          if (messageEl) {
            messageEl.textContent = 'Discount code has been copied to clipboard!';
            messageEl.className =
              'mt-product-detail__discount-message success';
            messageEl.classList.remove('hidden');
            setTimeout(() => messageEl.classList.add('hidden'), 3000);
          }
          setTimeout(() => button.classList.remove('copied'), 2000);
        } catch (err) {
          console.error('Failed to copy discount code:', err);
          if (messageEl) {
            messageEl.textContent = 'Copying failed. Please copy the discount code manually.';
            messageEl.className =
              'mt-product-detail__discount-message error';
            messageEl.classList.remove('hidden');
            setTimeout(() => messageEl.classList.add('hidden'), 3000);
          }
        }
      });
    });
  }

  // 倒计时
  const countdownEls = section.querySelectorAll('[data-discount-countdown]');
  countdownEls.forEach((el) => {
    const endStr = el.getAttribute('data-countdown-end');
    if (!endStr) return;
    const endTime = new Date(endStr.replace(/-/g, '/')).getTime();
    if (Number.isNaN(endTime)) return;

    function update() {
      const now = Date.now();
      let diff = Math.max(0, endTime - now);

      const seconds = Math.floor(diff / 1000) % 60;
      const minutes = Math.floor(diff / (1000 * 60)) % 60;
      const hours = Math.floor(diff / (1000 * 60 * 60));

      const pad = (n) => String(n).padStart(2, '0');
      el.innerHTML = `<span class="countdown-unit">${pad(hours)}<span class="countdown-label">h</span></span><span class="countdown-separator">:</span><span class="countdown-unit">${pad(minutes)}<span class="countdown-label">m</span></span><span class="countdown-separator">:</span><span class="countdown-unit">${pad(seconds)}<span class="countdown-label">s</span></span>`;
    }

    update();
    const interval = setInterval(() => {
      update();
      if (el.textContent === '00:00:00') {
        clearInterval(interval);
      }
    }, 1000);
  });
}

/* ----------------------------- Image upload UI ------------------------------ */

function initImageUploadForSection(section) {
  const uploadInput = section.querySelector('[data-image-upload]');
    if (!uploadInput) return;

  const uploadButton = section.querySelector('[data-upload-text]');
  const previewContainer = section.querySelector('[data-upload-preview]');
  const previewImage = section.querySelector('[data-upload-preview] img');
  const removeButton = section.querySelector('[data-upload-remove]');

    uploadInput.addEventListener('change', (e) => {
      const file = e.target.files[0];
    if (!file || !file.type.startsWith('image/')) return;

        const reader = new FileReader();
        reader.onload = (event) => {
      if (previewImage) previewImage.src = event.target.result;
      if (previewContainer) previewContainer.classList.remove('hidden');
      if (uploadButton) uploadButton.textContent = file.name;
        };
        reader.readAsDataURL(file);
    });

    if (removeButton) {
      removeButton.addEventListener('click', () => {
          uploadInput.value = '';
      if (previewContainer) previewContainer.classList.add('hidden');
      if (previewImage) previewImage.src = '';
      if (uploadButton) uploadButton.textContent = 'Choose File';
      });
    }
  }

/* ------------------------ Thumbnails & image carousel ----------------------- */

function initMtProductDetailThumbnails(root) {
  if (!root) return;
  const thumbnails = Array.from(
    root.querySelectorAll('.mt-product-detail__thumbnail')
  );
  const mediaItems = Array.from(
    root.querySelectorAll('.mt-product-detail__media-item')
  );
  if (!thumbnails.length || !mediaItems.length) return;

  const mediaOrder = mediaItems.map((item) => item.dataset.mediaIndex);

  // Sync thumbnails height with main image height
  function syncThumbnailsHeight() {
    if (window.innerWidth < 750) return; // Only on desktop
    
    const thumbnailsContainer = root.querySelector('.mt-product-detail__thumbnails');
    const activeMediaItem = root.querySelector('.mt-product-detail__media-item.is-active');
    
    if (!thumbnailsContainer || !activeMediaItem) return;
    
    const imageWrapper = activeMediaItem.querySelector('.mt-product-detail__image-wrapper');
    if (!imageWrapper) return;
    
    // Get the actual height of the active image wrapper
    const imageHeight = imageWrapper.offsetHeight;
    
    // Set thumbnails container height to match
    if (imageHeight > 0) {
      thumbnailsContainer.style.height = imageHeight + 'px';
    }
  }
  
  // Scroll thumbnails container to show active thumbnail
  function scrollToActiveThumbnail() {
    const thumbnailsContainer = root.querySelector('.mt-product-detail__thumbnails');
    const activeThumbnail = root.querySelector('.mt-product-detail__thumbnail.is-active');
    
    if (!thumbnailsContainer || !activeThumbnail) return;
    
    // Scroll the active thumbnail into view
    activeThumbnail.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest'
    });
  }

  function activateMedia(targetIndex) {
    if (targetIndex == null) return;
    const targetKey = String(targetIndex);
    
    // 重新查找 media items 和 thumbnails，确保包含动态添加的元素
    const currentMediaItems = Array.from(
      root.querySelectorAll('.mt-product-detail__media-item')
    );
    const currentThumbnails = Array.from(
      root.querySelectorAll('.mt-product-detail__thumbnail')
    );
    
    console.log('[mt-product-detail] activateMedia called with:', targetIndex, '->', targetKey);
    console.log('[mt-product-detail] Media items count:', currentMediaItems.length);
    console.log('[mt-product-detail] Thumbnails count:', currentThumbnails.length);
    console.log('[mt-product-detail] All media indexes:', currentMediaItems.map(item => item.dataset.mediaIndex));

    let activatedCount = 0;
    currentMediaItems.forEach((item) => {
      const isMatch = item.dataset.mediaIndex === targetKey;
      item.classList.toggle('is-active', isMatch);
      if (isMatch) {
        activatedCount++;
        console.log('[mt-product-detail] Activated media item:', item, 'data-media-index:', item.dataset.mediaIndex);
      }
    });
    
    currentThumbnails.forEach((thumb) => {
      const isMatch = thumb.dataset.mediaIndex === targetKey;
      thumb.classList.toggle('is-active', isMatch);
      if (isMatch) {
        console.log('[mt-product-detail] Activated thumbnail:', thumb, 'data-media-index:', thumb.dataset.mediaIndex);
      }
    });
    
    console.log('[mt-product-detail] Total activated media items:', activatedCount);
    
    // 如果没找到匹配的，输出警告
    if (activatedCount === 0) {
      console.warn('[mt-product-detail] No media item found with data-media-index="' + targetKey + '"');
      console.warn('[mt-product-detail] Available indexes:', currentMediaItems.map(item => item.dataset.mediaIndex));
    }
    
    // Sync thumbnails height after media activation
    setTimeout(syncThumbnailsHeight, 100);
    
    // Scroll to active thumbnail
    setTimeout(scrollToActiveThumbnail, 150);
  }

  // 导出 activateMedia 函数供其他模块使用
  root._activateMedia = activateMedia;

  thumbnails.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      activateMedia(thumb.dataset.mediaIndex);
    });
  });

  const prevBtn = root.querySelector('[data-nav="prev"]');
  const nextBtn = root.querySelector('[data-nav="next"]');

  function getCurrentIndex() {
    const active = root.querySelector('.mt-product-detail__media-item.is-active');
    if (!active) return 0;
    const currentKey = active.dataset.mediaIndex;
    const idx = mediaOrder.indexOf(currentKey);
    return idx >= 0 ? idx : 0;
  }

  function goToOffset(offset) {
    if (!mediaOrder.length) return;
    const currentIdx = getCurrentIndex();
    const nextIdx =
      (currentIdx + offset + mediaOrder.length) % mediaOrder.length;
    activateMedia(mediaOrder[nextIdx]);
  }

  if (prevBtn) prevBtn.addEventListener('click', () => goToOffset(-1));
  if (nextBtn) nextBtn.addEventListener('click', () => goToOffset(1));
  
  // Sync on init (但不自动滚动，避免页面刷新时跳转)
  setTimeout(() => {
    syncThumbnailsHeight();
    // 移除自动滚动，只在用户交互时滚动
    // scrollToActiveThumbnail();
  }, 100);
  
  // Sync on window resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(syncThumbnailsHeight, 250);
  });
  
  // Sync when images load
  const images = root.querySelectorAll('.mt-product-detail__image');
  images.forEach(img => {
    if (img.complete) {
      setTimeout(syncThumbnailsHeight, 100);
    } else {
      img.addEventListener('load', syncThumbnailsHeight);
    }
  });
}

/* ----------------------- Similar products (Shopify API) --------------------- */

function initSimilarProductsForSection(section) {
  const container = section.querySelector('[data-similar-products]');
  if (!container) return;

  const productId = container.dataset.productId;
  const limit = container.dataset.limit || 4;
  const wrapper = container.closest('.mt-product-detail__similar-products');
  if (!wrapper || !productId) return;

  container._products = [];
  container._currentIndex = 0;
  container._itemsPerPage = 2;

  async function loadSimilarProducts() {
    try {
      container.classList.add('loading');
      
      let url;
      if (window.Shopify?.routes?.product_recommendations_url) {
        url = `${window.Shopify.routes.product_recommendations_url}.json?product_id=${productId}&limit=${limit}&intent=related`;
      } else if (window.Shopify?.routes?.root) {
        url = `${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=${limit}&intent=related`;
      } else {
        url = `/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=related`;
      }

      const resp = await fetch(url);
      if (!resp.ok) {
        container.innerHTML = `<p>Unable to load similar products (${resp.status}).</p>`;
        return;
      }
      const data = await resp.json();
      if (!data.products || !data.products.length) {
        container.innerHTML = '<p>No similar products found.</p>';
        return;
      }

      const filtered = data.products.filter((p) => String(p.id) !== String(productId));
      if (!filtered.length) {
        container.innerHTML = '<p>No similar products found.</p>';
      return;
    }

      container._products = filtered;
      renderPage();
      bindArrows();
      bindButtons();
    } catch (err) {
      console.error('[MT Product Detail] similar products error', err);
      container.innerHTML = '<p>Unable to load similar products.</p>';
    } finally {
      container.classList.remove('loading');
    }
  }

  // 提取横杆后的文本
  function getTitleAfterDash(title) {
    if (!title) return title;
    // 匹配各种横杆：-、—、–、―
    const dashIndex = title.search(/[-—–―]/);
    if (dashIndex !== -1) {
      return title.substring(dashIndex + 1).trim();
    }
    return title;
  }

  function renderPage() {
    const currency = window.Shopify?.currency?.active || '$';
    const itemsPerPage = container._itemsPerPage || 2;
    const currentIndex = container._currentIndex || 0;
    const start = currentIndex * itemsPerPage;
    const end = start + itemsPerPage;
    const productsToShow = container._products.slice(start, end);
    
    container.innerHTML = productsToShow
      .map((product) => {
        const price = (product.price / 100).toFixed(2);
        const comparePrice = product.compare_at_price
          ? (product.compare_at_price / 100).toFixed(2)
          : null;
        const imageUrl =
          product.featured_image ||
          'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-1_large.png';
        const productUrl = product.url || `/products/${product.handle}`;

        return `
          <a href="${productUrl}" class="mt-product-collection__product-link">
            <div class="mt-product-collection__image-wrapper">
              <img src="${imageUrl}" alt="${escapeHtml(
                product.title
              )}" loading="lazy" class="mt-product-collection__image">
            </div>
            <div class="mt-product-collection__info">
              <h3 class="mt-product-collection__product-title">
                ${escapeHtml(getTitleAfterDash(product.title))}
              </h3>
              <div class="mt-product-collection__prices">
            ${
              comparePrice
                ? `<span class="mt-product-collection__price mt-product-collection__price--compare">${currency}${comparePrice}</span>
                     <span class="mt-product-collection__price mt-product-collection__price--sale">${currency}${price}</span>`
                : `<span class="mt-product-collection__price">${currency}${price}</span>`
            }
              </div>
              </div>
            </a>
        `;
      })
      .join('');
  }

  // <button type="button" class="mt-product-collection__button" data-product-url="${productUrl}">
//   CHOOSE IT
// </button>

  function bindArrows() {
    const prevBtn = wrapper.querySelector(
      '.mt-product-detail__similar-arrow--prev'
    );
    const nextBtn = wrapper.querySelector(
      '.mt-product-detail__similar-arrow--next'
    );
    if (prevBtn) {
      prevBtn.addEventListener('click', () => navigate(-1));
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => navigate(1));
    }
    updateArrows(prevBtn, nextBtn);
  }

  function bindButtons() {
    const buttons = container.querySelectorAll('.mt-product-collection__button');
    buttons.forEach((button) => {
      const productUrl = button.dataset.productUrl;
      if (productUrl) {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = productUrl;
        });
      }
    });
  }

  function navigate(direction) {
    if (!container._products || !container._products.length) return;
    const total = container._products.length;
    const per = container._itemsPerPage;
    const pages = Math.ceil(total / per);

    container._currentIndex += direction;
    container._currentIndex = Math.max(
      0,
      Math.min(container._currentIndex, pages - 1)
    );
    renderPage();
    bindButtons();

    const prevBtn = wrapper.querySelector(
      '.mt-product-detail__similar-arrow--prev'
    );
    const nextBtn = wrapper.querySelector(
      '.mt-product-detail__similar-arrow--next'
    );
    updateArrows(prevBtn, nextBtn);
  }

  function updateArrows(prevBtn, nextBtn) {
    if (!container._products || !container._products.length) {
      if (prevBtn) prevBtn.disabled = true;
      if (nextBtn) nextBtn.disabled = true;
      return;
    }
    const total = container._products.length;
    const per = container._itemsPerPage;
    const pages = Math.ceil(total / per);
    const page = container._currentIndex || 0;

    if (prevBtn) {
      prevBtn.disabled = page === 0;
      prevBtn.style.opacity = page === 0 ? '0.5' : '1';
    }
    if (nextBtn) {
      nextBtn.disabled = page >= pages - 1;
      nextBtn.style.opacity = page >= pages - 1 ? '0.5' : '1';
    }
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  loadSimilarProducts();
}

/* --------------------------- View details dialog ---------------------------- */

function initMtProductDetailViewDetails(section) {
  const dialog = section.querySelector('[data-mt-dialog]');
  if (!dialog) return;

  const body = dialog.querySelector('[data-mt-dialog-body]');
  const titleEl = dialog.querySelector('[data-mt-dialog-title]');
  const templatesRoot = section.querySelector(
    '.mt-product-detail__dialog-templates'
  );
  const defaultLabel =
    section.dataset.mtViewDetailsLabel || 'View details';
  const typeLabels = {
    upload:
      section.dataset.mtViewDetailsLabelUpload || defaultLabel,
    size: section.dataset.mtViewDetailsLabelSize || defaultLabel,
    framing:
      section.dataset.mtViewDetailsLabelFraming || defaultLabel,
  };
  if (!body || !titleEl) return;

  function openDialog(type, fallbackTitle) {
    let html = '';

    if (templatesRoot) {
      const tpl = templatesRoot.querySelector(
        `[data-mt-dialog-template="${type}"]`
      );
      if (tpl) {
        html = tpl.innerHTML.trim();
      }
    }

    if (!html) {
      html = '<p>No details available.</p>';
    }

    body.innerHTML = html;

    const labelForType =
      (type && typeLabels[type]) || defaultLabel;
    titleEl.textContent =
      (fallbackTitle && fallbackTitle.trim()) || labelForType;

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', 'true');
    }
  }

  function ensureViewDetailButtons() {
    const poContainers = section.querySelectorAll('.po-label-container');
    poContainers.forEach((container) => {
      if (container.querySelector('.mt-po-view-details')) return;

      const labelText = container.textContent.toLowerCase();
      let viewType = null;
      if (labelText.includes('size')) {
        viewType = 'size';
      } else if (labelText.includes('framing') || labelText.includes('frame')) {
        viewType = 'framing';
      }

      if (!viewType) return;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className =
        'mt-product-detail__view-details mt-po-view-details';
      btn.dataset.mtViewDetails = viewType;
      const labelForType =
        (viewType && typeLabels[viewType]) || defaultLabel;
      btn.textContent = labelForType;
      container.appendChild(btn);
    });

    const buttons = section.querySelectorAll('[data-mt-view-details]');
    buttons.forEach((btn) => {
      if (btn.dataset.mtViewDetailsBound === 'true') return;
      btn.dataset.mtViewDetailsBound = 'true';

      btn.addEventListener('click', () => {
        const type = btn.dataset.mtViewDetails;
        openDialog(type, '');
      });
    });
  }

  ensureViewDetailButtons();

  const observer = new MutationObserver(() => {
    ensureViewDetailButtons();
  });
  observer.observe(section, {
    childList: true,
    subtree: true,
  });

  const closeBtn = dialog.querySelector('[data-mt-dialog-close]');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    });
  }

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }
  });
}

/* ----------------------------- Global initialiser --------------------------- */

function initMTProductDetail() {
  const sections = document.querySelectorAll('[data-mt-product-detail]');
  sections.forEach((section) => {
    if (section.dataset.mtInitialized === 'true') return;
    section.dataset.mtInitialized = 'true';

    initMtProductDetailVariants(section);
    initDiscountCodeForSection(section);
    initImageUploadForSection(section);
    initSimilarProductsForSection(section);
    initMtProductDetailThumbnails(section);
    initMtProductDetailViewDetails(section);


    section
      .querySelectorAll('input[type="checkbox"]')
       .forEach((input) =>
         input.addEventListener('change', () => mtUpdateSubtotal(section))
       );

    const observeTargets = [];
    const bssPriceEl =
      document.querySelector('.bss-po-product-price') ||
      section.querySelector('.bss-po-product-price');
    const priceRoot = section.querySelector('[data-product-price]');
    if (bssPriceEl) observeTargets.push(bssPriceEl);
    if (priceRoot) observeTargets.push(priceRoot);

    observeTargets.forEach((el) => {
      const observer = new MutationObserver(() => mtUpdateSubtotal(section));
      observer.observe(el, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    });

    mtUpdateSubtotal(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMTProductDetail);
} else {
  initMTProductDetail();
}

/* --------------------------- Add to Cart Upload Check ---------------------------- */

function checkUploadBeforeAddToCart() {
  const customTable = document.getElementById('custom-table');
  if (!customTable) return true; 
  
  const uploadInput = customTable.querySelector('input[type="file"][sl-data-id]');
  if (!uploadInput) return true; 
  
  const uploadHiddenInputs = customTable.querySelectorAll('.sl-upload-origin-hidden-input, .sl-upload-preview-hidden-input');
  
  let hasUploadedImage = false;
  
  uploadHiddenInputs.forEach((input) => {
    if (input && input.value && input.value.trim() !== '') {
      hasUploadedImage = true;
    }
  });
  
  if (uploadInput && uploadInput.files && uploadInput.files.length > 0) {
    hasUploadedImage = true;
  }
  
  if (window._uploadedImages && Object.keys(window._uploadedImages).length > 0) {
    hasUploadedImage = true;
  }
  
  return hasUploadedImage;
}

function scrollToUploadArea() {
  const customTable = document.getElementById('custom-table');
  if (!customTable) return;
  
  const uploadWrapper = customTable.querySelector('.sl-upload-wrapper');
  const targetEl = uploadWrapper || customTable;
  
  targetEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  
  // 高亮
  if (uploadWrapper) {
    uploadWrapper.style.transition = 'box-shadow 0.3s ease';
    uploadWrapper.style.boxShadow = '0 0 0 3px #C84835';
    setTimeout(() => {
      uploadWrapper.style.boxShadow = '';
    }, 2000);
  }
}

function initAddToCartUploadCheck() {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.mt-product-detail__add-to-cart, .po-atc-btn, .mt-now-buy2');
    if (!btn) return;
    
    // 对于 .mt-now-buy2，不需要检查 section（它可能在 sticky bar 中）
    if (btn.classList.contains('mt-now-buy2')) {
      if (!checkUploadBeforeAddToCart()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        scrollToUploadArea();
        console.log('[mt-product-detail] 请先上传图片');
        return false;
      }
      // 如果已上传图片，允许继续跳转
      return true;
    }
    
    const section = btn.closest('[data-mt-product-detail]');
    if (!section) return;
    
    if (!checkUploadBeforeAddToCart()) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      scrollToUploadArea();
      console.log('[mt-product-detail] 请先上传图片');
      return false;
    }
  }, true); 
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.closest('[data-mt-product-detail]')) return;
    if (form.getAttribute('data-type') !== 'add-to-cart-form') return;
    
    if (!checkUploadBeforeAddToCart()) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      scrollToUploadArea();
      console.log('[mt-product-detail] 请先上传图片');
      return false;
    }
  }, true); 
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAddToCartUploadCheck);
} else {
  initAddToCartUploadCheck();
}

/* --------------------------- Image View Dialog ---------------------------- */

function initImageDialog(section) {
  const dialog = section.querySelector('[data-image-dialog]');
  const viewButtons = section.querySelectorAll('[data-view-image]');
  const dialogImage = section.querySelector('[data-dialog-image]');
  const closeButton = section.querySelector('[data-dialog-close]');
  const prevButton = section.querySelector('[data-dialog-nav="prev"]');
  const nextButton = section.querySelector('[data-dialog-nav="next"]');
  const imageWrapper = section.querySelector('.mt-product-detail__image-dialog-image-wrapper');

  if (!dialog || !dialogImage || !closeButton) return;

  const images = Array.from(viewButtons).map((button) => ({
    url: button.dataset.imageUrl,
    alt: button.dataset.imageAlt || 'Product image'
  })).filter(img => img.url); 

  let currentImageIndex = -1;

  const updateImage = (index) => {
    if (index < 0 || index >= images.length) return;
    
    currentImageIndex = index;
    const image = images[index];
    dialogImage.src = image.url;
    dialogImage.alt = image.alt;
    
    if (prevButton) {
      prevButton.style.display = images.length > 1 ? 'flex' : 'none';
      prevButton.disabled = index === 0;
    }
    if (nextButton) {
      nextButton.style.display = images.length > 1 ? 'flex' : 'none';
      nextButton.disabled = index === images.length - 1;
    }
  };

  // 移动端阻止页面滚动
  const isMobile = window.innerWidth <= 749;
  let scrollPosition = 0;
  let bodyFixed = false;
  let activeButton = null; // 保存触发 dialog 的按钮

  const lockBodyScroll = () => {
    if (!isMobile || bodyFixed) return;
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    bodyFixed = true;
  };

  const unlockBodyScroll = () => {
    if (!isMobile || !bodyFixed) return;
    
    // 先恢复 body 样式
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    
    // 使用 requestAnimationFrame 确保在 DOM 更新后恢复滚动位置
    requestAnimationFrame(() => {
      // 临时禁用平滑滚动，立即恢复位置，避免动画滚动
      const originalScrollBehavior = document.documentElement.style.scrollBehavior;
      const originalBodyScrollBehavior = document.body.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      document.body.style.scrollBehavior = 'auto';
      
      // 立即恢复滚动位置，不使用平滑滚动
      window.scrollTo({
        top: scrollPosition,
        left: 0,
        behavior: 'auto'
      });
      
      // 恢复原始滚动行为
      requestAnimationFrame(() => {
        document.documentElement.style.scrollBehavior = originalScrollBehavior;
        document.body.style.scrollBehavior = originalBodyScrollBehavior;
      });
    });
    
    bodyFixed = false;
  };

  viewButtons.forEach((button, index) => {
    button.addEventListener('click', (e) => {
      const imageUrl = button.dataset.imageUrl;
      const imageAlt = button.dataset.imageAlt || 'Product image';
      
      if (imageUrl) {
        const imageIndex = images.findIndex(img => img.url === imageUrl);
        if (imageIndex !== -1) {
          activeButton = button; // 保存触发按钮
          updateImage(imageIndex);
          dialog.showModal();
          lockBodyScroll();
        }
      }
    });
  });

  if (prevButton) {
    prevButton.addEventListener('click', (e) => {
      e.stopPropagation();
      if (currentImageIndex > 0) {
        updateImage(currentImageIndex - 1);
      }
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', (e) => {
      e.stopPropagation();
      if (currentImageIndex < images.length - 1) {
        updateImage(currentImageIndex + 1);
      }
    });
  }

  dialog.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      closeDialog();
    } else if (e.key === 'ArrowLeft' && currentImageIndex > 0) {
      updateImage(currentImageIndex - 1);
    } else if (e.key === 'ArrowRight' && currentImageIndex < images.length - 1) {
      updateImage(currentImageIndex + 1);
    }
  });

  const closeDialog = () => {
    // 阻止浏览器自动将焦点返回到触发元素（这会导致滚动）
    if (activeButton && activeButton instanceof HTMLElement) {
      activeButton.blur();
    }
    
    dialog.close();
    unlockBodyScroll();
    
    // 清除保存的按钮引用
    activeButton = null;
  };

  closeButton.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    closeDialog();
  });

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) {
      closeDialog();
    }
  });

  // 监听弹窗关闭事件
  dialog.addEventListener('close', () => {
    // 确保在关闭时也解锁滚动
    unlockBodyScroll();
    // 清除保存的按钮引用
    activeButton = null;
  });

  // 移动端触摸滑动切换图片
  if (imageWrapper && images.length > 1) {
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    let isSwiping = false;

    const handleTouchStart = (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isSwiping = false;
    };

    const handleTouchMove = (e) => {
      if (!touchStartX || !touchStartY) return;
      
      touchEndX = e.touches[0].clientX;
      touchEndY = e.touches[0].clientY;
      
      const deltaX = touchEndX - touchStartX;
      const deltaY = touchEndY - touchStartY;
      
      // 判断是否为水平滑动（水平距离大于垂直距离）
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
        isSwiping = true;
        // 阻止默认滚动行为
        e.preventDefault();
      }
    };

    const handleTouchEnd = (e) => {
      if (!touchStartX || !touchStartY) return;
      
      touchEndX = e.changedTouches[0].clientX;
      touchEndY = e.changedTouches[0].clientY;
      
      const deltaX = touchEndX - touchStartX;
      const deltaY = touchEndY - touchStartY;
      const minSwipeDistance = 50; // 最小滑动距离
      
      // 判断是否为有效的水平滑动
      if (isSwiping && Math.abs(deltaX) > minSwipeDistance && Math.abs(deltaX) > Math.abs(deltaY)) {
        if (deltaX > 0) {
          // 向右滑动，显示上一张
          if (currentImageIndex > 0) {
            updateImage(currentImageIndex - 1);
          }
        } else {
          // 向左滑动，显示下一张
          if (currentImageIndex < images.length - 1) {
            updateImage(currentImageIndex + 1);
          }
        }
      }
      
      // 重置
      touchStartX = 0;
      touchStartY = 0;
      touchEndX = 0;
      touchEndY = 0;
      isSwiping = false;
    };

    imageWrapper.addEventListener('touchstart', handleTouchStart, { passive: false });
    imageWrapper.addEventListener('touchmove', handleTouchMove, { passive: false });
    imageWrapper.addEventListener('touchend', handleTouchEnd, { passive: true });
  }
}

function initAllImageDialogs() {
  const sections = document.querySelectorAll('[data-mt-product-detail]');
  sections.forEach((section) => {
    initImageDialog(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllImageDialogs);
} else {
  initAllImageDialogs();
}

/* --------------------------- Reviews Link Scroll ---------------------------- */

function initReviewsLinkScroll() {
  document.querySelectorAll('.mt-product-detail__reviews-link').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      
      const selectors = [
        '#air-reviews-widget',
        '#airreviews-widget',
        '[id*="air-reviews"]',
        '[id*="airreviews"]',
        '[id*="air_reviews"]',
        '.air-reviews-widget',
        '.airreviews-widget',
        '[class*="air-reviews"]',
        '[class*="airreviews"]',
        '[data-app="air-reviews"]',
        '[data-app="airreviews"]',
        '[id*="shopify-block"][id*="air-product-reviews"]',
        'shopify-app-block[id*="air-product-reviews"]',
        '#product-reviews',
        '.product-reviews',
        '#reviews',
        '.reviews-section'
      ];
      
      let reviewsSection = null;
      for (const selector of selectors) {
        try {
          reviewsSection = document.querySelector(selector);
          if (reviewsSection) {
            console.log('[mt-product-detail] Found reviews section:', selector);
            break;
          }
        } catch (err) {
          // 忽略无效选择器错误
        }
      }
      
      if (reviewsSection) {
        reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        console.log('[mt-product-detail] Reviews section not found. Available elements with "review" in id/class:');
        document.querySelectorAll('[id*="review"], [class*="review"]').forEach((el) => {
          console.log('  -', el.tagName, el.id ? `#${el.id}` : '', el.className);
        });
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReviewsLinkScroll);
} else {
  initReviewsLinkScroll();
}